// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__Mpttd","label":"Completed_label__SB_U_"};